import React, { useEffect, useRef } from 'react';
import { Container, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Box, Grid2, ListItemIcon, useTheme } from '@mui/material';
import WebBanner from '../../layouts/WebLayout/components/WebBanner/WebBanner';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Term from '../../assets/images/terms.svg';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../../layouts/WebLayout/SkipToMainContent/SkipToMainContentSlice';

const Disclaimer = () => {
  const theme = useTheme();
  const dynamicTextColor = theme.palette.mode === "light" ? "#333333" : "#fff";
  const skipClicked=useSelector((state:any)=>
    {
       return state?.skip?.SkipButtonClicked
   });
const dispatch=useDispatch();
const sectionRef = useRef<HTMLElement | null>(null);
const handleScroll = () => {
   if (sectionRef.current) {
     sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
     dispatch(reset());
   }
 }
 useEffect(()=>{
   if(skipClicked){
   handleScroll() 
   } 
 },[skipClicked])

  const numberStyles = {
    backgroundColor: '#fff',
    color: '#1976d2',
    border: '2px solid #1976d2',
    fontWeight: 'bold',
  };
  return (
    <>
      <WebBanner
        title="Disclaimer"
        subtitle=" "
        image={Term}
      />
      <Container maxWidth="xl">
        <Box sx={{padding:{ xs:"2rem 0",sm:"1rem 0"}}}>
          <Grid2 container sx={{
            justifyContent: "center"
          }}  ref={sectionRef as any}>
            <Grid2 size={12}  sx={{margin:{ xs:"2rem 0",sm:"3rem 0"}}}>
              <Typography variant="body1" sx={{fontSize:{xs:`calc(1em * var(--dynamic-font-size, 1))`,sm:`calc(1.25em * var(--dynamic-font-size, 1))`}, lineHeight: "40px", color: dynamicTextColor}}>
               Content on this website is published and managed by National Highways Authority of India. For any query regarding this website please contact the NHAI HQ, Delhi (<a
                href="https://nhai.gov.in"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }} // optional styling
              >
                 https://nhai.gov.in
              </a>)
              </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </Container>
    </>
  );
};

export default Disclaimer;
